export default class FooterAccordion {
  constructor(element) {
    this.element = element;
    this.parent = this.element.parentElement;
    this.header = this.element.querySelector('.footer-accordion__head');
    this.links = this.element.querySelector('.footer-accordion__links');

    if (this.links) {
      this.header.addEventListener('click', (e) => {
        e.preventDefault();

        if (window.innerWidth <= 1279) {
          this.toggleActive();
        }
      });
    }
  }

  toggleActive() {
    if (this.element.classList.contains('footer-accordion--open')) {
      this.links.style = null;
      this.element.classList.remove('footer-accordion--open');
    } else {
      const active = this.parent.querySelector('.footer-accordion--open');
      if (active) {
        const activeLinks = active.querySelector('.footer-accordion__links');
        if (activeLinks) {
          activeLinks.style = null;
        }
        active.classList.remove('footer-accordion--open');
      }
      this.element.classList.add('footer-accordion--open');
      this.links.style.maxHeight = `${this.links.scrollHeight}px`;
    }
  }
}



// WEBPACK FOOTER //
// ./blocks/footer/accordion/footer-accordion.js